import React, { Component } from 'react';
import ReactLoading from 'react-loading'

class ReactLoadingTop extends Component {

  constructor(props) {
    super(props);
  }

  render() {

    let style = {position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%,-50%)', fill: "#333333"};
    style = Object.assign(style, this.props.style || {});

    let divStyle = {left: 0, top: 0, position: 'absolute', width: '100%', height: '100%'}

    if (!this.props.transparent)
      divStyle.backgroundColor = '#00000011';

    return <div style={divStyle}>
      <ReactLoading type="spinningBubbles" style={style}/>
    </div>
  }
}

export default ReactLoadingTop;
